export const MOCK_ALERT_LEVER = [
  { id: '1', name: 'Thông báo' },
  { id: '2', name: 'Cảnh báo' },
  { id: '3', name: 'Nghiêm trọng' },
];

export const MOCK_STATUS = [
  { id: '1', name: 'Đang diễn ra' },
  { id: '2', name: 'Chưa xử lý' },
  { id: '3', name: 'Đã xử lý' },
];

export const MOCK_ALERT_SUBJECT = [
  { id: '1', name: 'Cảnh báo cháy' },
  { id: '2', name: 'Thiết bị' },
  { id: '3', name: 'Người dùng' },
  { id: '4', name: 'Đại lý & Nhà phân phối' },
];
